import React from 'react';
import GoogleMapReact from 'google-map-react';
import Clustermarker from '../clusterMarker/ClusterMarker';
import Simplemarker from '../simpleMarker/SimpleMarker';
import { GMapHOC } from './GMapHOC';


export const GMap = ({
  defaultStyle, hoverDistance, options,
  mapProps: { center, zoom },
  onChange, onChildMouseEnter, onChildMouseLeave,
  clusters, style,
}) => (
  <GoogleMapReact bootstrapURLKeys={{
    key: `${process.env.REACT_APP_GOOGLE_MAPS_KEY}`,
  }}
    style={{
      ...defaultStyle,
      ...style,
    }}
    options={options}
    hoverDistance={hoverDistance}
    center={center}
    zoom={zoom}
    onChange={onChange}
    onChildMouseEnter={onChildMouseEnter}
    onChildMouseLeave={onChildMouseLeave}
  >
    {
      clusters.map(({
        markerId,
        numPoints,
        ...markerProps
      },) => (
        numPoints === 1 ? (
          <Simplemarker key={markerId}
            {...markerProps}
          />
        )
          : (
            <Clustermarker key={markerId}
              {...markerProps}
            />
          )
      ))
    }

  </GoogleMapReact>
);

export default GMapHOC(GMap);
